import {AfterViewInit, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {User} from '@models/user';
import {SchoolService} from '@services/school/school.service';
import {ProgramService} from '@services/program/program.service';
import {StudentService} from '@services/student/student.service';
import {TeacherService} from '@services/teacher/teacher.service';
import {SchoolOwner} from '@interfaces/schoolOwner';
import * as $ from 'jquery';
import {BehaviorSubject} from '@node_modules/rxjs';
import {Program} from '@models/program';
import {Class} from '@models/class';
import {School} from '@models/shool';
import {SetPrograms} from '@store/program/actions';
import {Curriculum} from '@models/curriculum';
import {CurriculumService} from '@services/curriculum/curriculum.service';

@Component({
  selector: 'app-add-recipients',
  templateUrl: './add-recipients.component.html',
  styleUrls: ['./add-recipients.component.scss']
})
export class AddRecipientsComponent implements OnInit, AfterViewInit {
  // Required inputs
  @Input() activeTab;
  @Input() user: User;
  @Input() parentRef;
  @Input() programs: Program[];
  @Input() classes: Class[];
  @Input() schools: School[];
  @Input() curriculums: Curriculum[];
  selectionChanged = new BehaviorSubject<any>(null);
  selectionRecipientsRoleChanged = new BehaviorSubject<any>(null);
  selectedThreadId: number;
  selectedMessage: boolean;
  recipients: number[] = [];
  bundleRecipients;
  // Outputs
  setRecieversSubject: BehaviorSubject<{id: number, itemName: string}[]> = new BehaviorSubject<{id: number, itemName: string}[]>(null);

  currentUsersLisSubject: BehaviorSubject<User[]> = new BehaviorSubject<User[]>(null);
  pageRecieversTeachers = 1;
  pageRecieversStudents = 1;
  pageRecieversUsers = 1;
  activeTabRecievers = 'all';
  selectedRecipients = [];
  checkAllStatus = false;
  schoolsTeachers = [];
  schoolsStudents = [];
  recipientsUsers = [];
  schoolsUsers = [];
  schoolsOwners: SchoolOwner[] = [];
  selectedProgramId = 0;
  selectedClassId = 0;
  selectedSchoolId = 0;
  selectedCurriculumId = 0;
  selectedCurriculumProgramId = 0;
  allPrograms: any = 0;
  programsById = {};

  constructor(
    private schoolService: SchoolService,
    private studentService: StudentService,
    private programService: ProgramService,
    private teacherService: TeacherService,
    private curriculumService: CurriculumService,
  ) { }

  ngOnInit() {
    this.selectedSchoolId = this.user.activeSchool ? this.user.activeSchool : 0;
    this.activeTabRecievers = this.user.notAdmin  ?  'school_owner' : 'all';
    if (this.user.notAdmin) {
      this.allPrograms = this.user.programs_id;
    }
    this.selectedProgramId = this.allPrograms;
    if (this.activeTab !== 'system-messages') {
      this.getRecievers();
    }
    this.getCurriculums();
  }
  ngAfterViewInit() {
    const textarea = document.querySelector('textarea');
    if (textarea) {
      textarea.addEventListener('keydown', this.autosize);
    }
  }
  setActiveTabRecievers(tab: string) {
    if (this.activeTab !== tab) {
      this.pageRecieversTeachers = 1;
      this.pageRecieversStudents = 1;
      this.pageRecieversUsers = 1;
      this.activeTabRecievers = tab;
      this.schoolsTeachers = [];
      this.schoolsStudents = [];
      this.schoolsUsers = [];
      if (tab === 'students') {
        this.selectedClassId = 0;
      }
      if (this.activeTab !== 'system-messages') {
        this.getRecievers();
      } else {
        this.bundleRecipients = {
          school: this.selectedSchoolId,
          program: this.selectedProgramId,
          classc: this.selectedClassId,
          curriculum: this.selectedCurriculumId,
          selectedCurriculumProgramId: this.selectedCurriculumProgramId,
        };
        const selectedItems = [];
        Object.keys(this.bundleRecipients).map(i => {
          if (i !== 'selectedCurriculumProgramId') {
            if (this.bundleRecipients[i] !== 0) {
              let models = null;
              switch (i) {
                case 'school': {
                  models = this.schools;
                  break;
                }
                case 'program': {
                  models = this.programs;
                  break;
                }
                case 'classc': {
                  models = this.classes;
                  break;
                }
                case 'curriculum': {
                  models = this.curriculums;
                  break;
                }
              }
              models.map(item => {
                if (item.id === this.bundleRecipients[i] && (i !== 'curriculum' || i === 'curriculum' && item.program_id === this.selectedCurriculumProgramId)) {
                  const name = item.program_name ? item.program_name : item.name;
                  selectedItems.push({id: item.id, itemName: name});
                }
              });
            }
          }
        });
        this.selectionChanged.next({recievers: this.bundleRecipients, selectedItems: selectedItems});
        this.selectionRecipientsRoleChanged.next(tab);
      }
    }
  }
  getRecievers() {
    console.log(this.user);
    switch (this.activeTabRecievers) {
      case 'school_owner': {
        if (this.schoolsOwners.length === 0) {
          this.programService.getSchoolOwner(this.user.programs_id).subscribe(
            (resp: { data: SchoolOwner[] }) => {
              this.schoolsOwners.push(...resp.data);
            }
          );
        }
        break;
      }
      default : {
        let programId = null;
        if (Array.isArray(this.selectedProgramId)) {
          programId = this.selectedProgramId.join(',');
        } else {
          programId = +this.selectedProgramId;
        }
        this.schoolService.getUsers(this.selectedSchoolId, this.pageRecieversUsers, programId, this.selectedClassId, this.selectedCurriculumId, this.activeTabRecievers).subscribe(
          (resp: { data: User[] }) => {
            switch (this.activeTabRecievers) {
              case 'all': {
                this.schoolsUsers.push(...resp.data);
                this.pageRecieversUsers++;
                break;
              }
              case 'students': {
                this.schoolsStudents.push(...resp.data);
                this.pageRecieversStudents++;
                break;
              }

              case 'teachers': {
                this.schoolsTeachers.push(...resp.data);
                this.pageRecieversTeachers++;
                break;
              }
            }
          }
        );
      }
    }
    this.getRecipients();
  }
  getRecipients(input = null) {
    console.log(input);
    let searchString = null;
    if (input) {
      searchString = input.value;
    }
    // if (this.creatingNew) {
    //   if (this.selectedThreadId) {
    //     return this.recipientsUsers;
    //   }
    //   switch (this.activeTabRecievers) {
    //     case 'all': {
    //       return this.schoolsUsers;
    //     }
    //     case 'teachers': {
    //       return this.schoolsTeachers;
    //     }
    //     case 'students': {
    //       return this.schoolsStudents;
    //     }
    //     case 'school_owner': {
    //       return this.schoolsOwners;
    //     }
    //   }
    // } else if (this.selectedMessage) {
    //   return this.recipientsUsers;
    // }
    let users = [];
    if (this.selectedThreadId) {
      users = this.recipientsUsers;
    } else {
      switch (this.activeTabRecievers) {
        case 'all': {
          users = this.schoolsUsers;
          break;
        }
        case 'teachers': {
          users = this.schoolsTeachers;
          break;
        }
        case 'students': {
          users = this.schoolsStudents;
          break;
        }
        case 'school_owner': {
          users = this.schoolsOwners;
          break;
        }
      }
    }
    searchString && searchString.length > 0 ? this.currentUsersLisSubject.next(this.search(users, searchString)) : this.currentUsersLisSubject.next(users);
  }
  autosize(e){
    const el = e.target;
    setTimeout(function(){
      el.style.cssText = 'height:auto; padding:0';
      el.style.cssText = 'height:' + el.scrollHeight + 'px';
    },0);
    $('#checkall').on('click', function () {
      if ($(this).hasClass('check')) {
        $(this).removeClass('check');
        $(this).find('span').text('Uncheck');
        $('.receiver input').prop( "checked", true );
      } else {
        $(this).addClass('check');
        $(this).find('span').text('Check');
        $('.receiver input').prop( "checked", false );
      }
    });
  }

  showSearch() {
    const input = document.getElementById("searchLine");
    const inputSearchLine = document.getElementById("searchLineInput") as HTMLInputElement;
    const element = document.getElementById("showBtn");

    if (element.classList) {
      element.classList.toggle("open");
      input.classList.toggle("open");
      console.log(element, input);
      if (!input.classList.contains("open")) {
        inputSearchLine.value = '';
        this.getRecipients();
      }
    } else {
      const classes = element.className.split(" ");
      const i = classes.indexOf("open");

      if (i >= 0) {
        classes.splice(i, 1);
      }
      else
        classes.push("open");
      element.className = classes.join(" ");

      const classesSecond = input.className.split(" ");
      const j = classesSecond.indexOf("open");

      if (j >= 0) {
        classesSecond.splice(j, 1);
      }
      else
        classesSecond.push("open");
      input.className = classesSecond.join(" ");
    }
  }
  search(users: User[], searchString): User[] {
    // console.log(users, searchString);
    users = users.filter( item => {
      // console.log(item);
      return item.name.toLowerCase().indexOf(searchString.toLowerCase()) !== -1; // || item.first_name.indexOf(searchString) !== -1 || item.last_name.indexOf(searchString) !== -1
    });
    console.log(users);
    return users;
  }
  checkAll() {
    console.log(this.activeTabRecievers);
    if (this.checkAllStatus) {
      this.recipients = [];
    } else {
      let models = [];
      switch (this.activeTabRecievers) {
        case 'all': {
          models = this.schoolsUsers;
          break;
        }
        case 'teachers': {
          models = this.schoolsTeachers;
          break;
        }
        case 'students': {
          models = this.schoolsStudents;
          break;
        }
        case 'school_owner': {
          models = this.schoolsOwners;
          break;
        }
      }
      this.recipients = [];
      models.map( u => {
        this.recipients.push(u.id);
      });
    }
    this.checkAllStatus = !this.checkAllStatus;
    console.log(this.recipients);
    this.setRecieversToSubject();
  }
  setReciever(event, id: number) {
    if (!this.selectedThreadId) {
      if (event.target.checked) {
        this.recipients.push(id);
      } else {
        this.recipients = this.recipients.filter( r => r !== id);
      }
    }
    this.setRecieversToSubject();
    console.log(this.recipients);
  }
  setRecieversToSubject() {
    this.currentUsersLisSubject.value.map( u => {
      let found = false;
      this.selectedRecipients.map( i => {
        if (i.id === u.id) {
          found = true;
        }
      });
      if (!found && this.recipients.includes(u.id)) {
        this.selectedRecipients.push({id: u.id, itemName: u.name})
      }
    });
    this.selectedRecipients = this.selectedRecipients.filter( c => this.recipients.includes(c.id));
    this.setRecieversSubject.next(this.selectedRecipients);
  }
  selectedProgramClass(event, mode: string) {
    console.log(event);
    switch (mode) {
      case 'program': {
        this.selectedProgramId = event.value;
        this.selectedClassId = 0;
        this.selectedCurriculumId = 0;
        this.selectedCurriculumProgramId = 0;
        this.selectedSchoolId = 0;
        break;
      }
      case 'class': {
        this.selectedClassId = +event.value;
        this.selectedCurriculumId = 0;
        this.selectedCurriculumProgramId = 0;
        this.selectedSchoolId = 0;
        this.selectedProgramId = this.allPrograms;
        break;
      }
      case 'school': {
        this.selectedSchoolId = +event.value;
        this.selectedProgramId = this.allPrograms;
        this.selectedClassId = 0;
        this.selectedCurriculumId = 0;
        this.selectedCurriculumProgramId = 0;
        this.getPrograms();
        break;
      }
      case 'curriculum': {
        const partIds = event.value.split('|');
        this.selectedCurriculumId = +partIds[0];
        this.selectedCurriculumProgramId = +partIds[1];
        this.selectedClassId = 0;
        this.selectedSchoolId = 0;
        this.selectedProgramId = 0;
        this.getPrograms();
        break;
      }
    }
    this.setActiveTabRecievers(this.activeTabRecievers);
  }

  getPrograms() {
    if (this.parentRef) {
      this.programService.getUsersPrograms(this.selectedSchoolId).subscribe(
        (resp: {data: Program[]}) => {
          this.programs = resp.data;
          const clIds = [];
          this.classes = [];
          this.programs.map(pr => {
            pr.classes.map(cl => {
              // console.log(cl, clIds);
              if (!clIds.includes(cl.id)) {
                this.classes.push(cl);
                clIds.push(cl.id);
              }
            });
          });
          this.getCurriculums();
        }
      );
    }
  }
  getCurriculums() {
    if (this.programs.length > 0 && !this.user.notAdmin) {
      const prIds = [];
      this.programsById = {};
      this.programs.map( pr => {
        if (!prIds.includes(pr.id)) {
          prIds.push(pr.id);
          this.programsById[pr.id] = pr;
        }
      });
      this.curriculumService.getByProgramIds(prIds).subscribe(
        (resp: {data: Curriculum[]}) => {
          resp.data.map((c,i) => {
            resp.data[i].name += ' - ' + this.programsById[c.program_id].program_name;
          });
          this.curriculums = resp.data;
        }
      );
    }
  }
}
